var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('b-container',{staticClass:"mt-5"},[_c(_vm.compiledTemplate,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }